export default __webpack_public_path__ + "static/media/South Cleave of the Vermillion Bird.a4878221.jpg";